export interface PreviewSettings {
  hasAiFeature?: boolean;
  hasHrFeature?: boolean;
  hasCustomReportsFeature?: boolean;
  [key: string]: any;
}

export class TokenHelper {
  private static urlBase64Decode(str: string): string {
    let output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
      case 0:
        break;
      case 2:
        output += '==';
        break;
      case 3:
        output += '=';
        break;
      default:
        throw new Error('Illegal base64url string!');
    }
    return output;
  }

  static getPreviewSettings(userId: number): PreviewSettings | null {
    try {
      const userData =
        localStorage.getItem('USER_DATA') ||
        sessionStorage.getItem('USER_DATA');
      if (!userData) return null;

      const data = JSON.parse(userData);
      if (!data.token) return null;

      const payloadBase64 = data.token.split('.')[1];
      let payload: any;

      try {
        payload = JSON.parse(atob(this.urlBase64Decode(payloadBase64)));
      } catch {
        payload = JSON.parse(atob(payloadBase64));
      }

      return payload.previewSettings;
    } catch {
      return null;
    }
  }

  private static toBoolean(value: any): boolean {
    if (typeof value === 'boolean') {
      return value;
    }
    if (typeof value === 'string') {
      return value.toLowerCase() === 'true';
    }
    return false;
  }

  static hasFeature(featureKey: string, userId: number): boolean {
    const previewSettings = this.getPreviewSettings(userId);
    if (!previewSettings) return false;

    const value = previewSettings[featureKey];
    return this.toBoolean(value);
  }

  static hasAiFeature(userId: number): boolean {
    return this.hasFeature('hasAiFeature', userId);
  }

  static hasHrFeature(userId: number): boolean {
    return this.hasFeature('hasHrFeature', userId);
  }

  static hasCustomReportsFeature(userId: number): boolean {
    return this.hasFeature('hasCustomReportsFeature', userId);
  }
}
